export const blockIconsTextformattingDescriptionNew = (
	<span className='material-symbols-outlined'>description</span>
);
